let utils = require('../../utils')
import AppHeader from '../AppHeader'

export default {
  name: 'master-supplier-new',
  created () {
  },
  data () {
    return {
      canValidate: true,
      name: '',
      name_hurigana: '',
      responsible_name: '',
      tel_no: '',
      fax_no: '',
      mail: '',
      postal_code: '',
      address: '',
      order_method: '',
      fee_type: 'no_fee',
      isSaving: false
    }
  },
  computed: {
    validation () {
      let hiragana = /^[\u3040-\u309fー]+$/
      let tel = /^0\d{1,4}-\d{1,4}-\d{3,4}$/
      let email = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/

      const validation = {
        name: !!this.name,
        name_hurigana: !!this.name_hurigana && hiragana.test(this.name_hurigana),
        responsible_name: !!this.responsible_name,
        tel_no: !!this.tel_no && tel.test(this.tel_no),
        fax_no: this.order_method !== 'fax' || (tel.test(this.fax_no) || !!this.fax_no),
        mail: this.order_method !== 'email' || (!!this.mail && email.test(this.mail)),
        postal_code: !!this.postal_code,
        address: !!this.address,
        order_method: !!this.order_method,
        fee_type: !!this.fee_type
      }
      if (!this.canValidate) {
        Object.keys(validation).forEach(
          key => {
            validation[key] = true
          }
        )
      }
      return validation
    },
    validationAll () {
      if (!this.validation.name) return false
      if (!this.validation.name_hurigana) return false
      if (!this.validation.responsible_name) return false
      if (!this.validation.tel_no) return false
      if (!this.validation.fax_no) return false
      if (!this.validation.mail) return false
      if (!this.validation.postal_code) return false
      if (!this.validation.address) return false
      if (!this.validation.order_method) return false
      if (!this.validation.fee_type) return false
      return true
    }
  },
  components: {
    AppHeader
  },
  methods: {
    async onChangePostNo () {
      if (this.postal_code) {
        this.postal_code = this.postal_code.replace(/-/g, '')
      }

      if (!!this.postal_code && utils.regex.post_no.test(this.postal_code)) {
        this.$store.dispatch('ADDRESS_GET', {
          postal_code: this.postal_code,
          callback: (addr) => {
            if (addr) {
              this.address = addr.address1 + addr.address2
              if (!utils.isBlank(this.address)) {
                this.address = utils.emHalf(this.address)
              }

              let arr = []
              if (utils.isPresent(this.postal_code)) {
                arr.push(this.postal_code)
              }
              if (utils.isPresent(this.address)) {
                arr.push(this.address)
              }

              if (arr.length > 0) {
                let address = arr.join(' ')
                if (window.googleMapsQuerySearch) {
                  window.googleMapsQuerySearch(address)
                }
              }
            }
          }
        })
      }
    },
    async onClickSave () {
      // 連打対応
      if (this.isSaving) return false
      this.isSaving = true

      // 保存処理
      await this.$store.dispatch('CREATE_MASTER_SUPPLIER', {
        data: {
          name: this.name,
          name_hurigana: this.name_hurigana,
          responsible_name: this.responsible_name,
          tel_no: this.tel_no,
          fax_no: this.fax_no,
          mail: this.mail,
          postal_code: this.postal_code,
          address: this.address,
          order_method: this.order_method,
          fee_type: this.fee_type
        }
      })
      .catch(err => {
        console.error(err)
        return
      })

      // サプライヤー一覧へ戻る
      this.$router.push('/master_supplier_list')
    },
    onClickCancel () {
      this.$router.push('/master_supplier_list')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/master-supplier-new.js